import { createSelector } from '@reduxjs/toolkit';
import { emptyObject } from 'vet-bones/constants';

import { projectSelector } from 'src/selectors/project';
import { ProjectFileUpload } from 'src/store/state/projects';

export const projectFileUploadsByIdSelector = (projectId: string) =>
  createSelector(
    projectSelector(projectId),
    (project) =>
      project?.fileUploadsById ||
      (emptyObject as unknown as Record<string, ProjectFileUpload>)
  );
